import { render, staticRenderFns } from "./Cursos-talleres.vue?vue&type=template&id=0686f6ad&scoped=true"
import script from "./Cursos-talleres.vue?vue&type=script&lang=js"
export * from "./Cursos-talleres.vue?vue&type=script&lang=js"
import style0 from "./Cursos-talleres.vue?vue&type=style&index=0&id=0686f6ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0686f6ad",
  null
  
)

export default component.exports